// extracted by mini-css-extract-plugin
export default {"cls1":"MJkp9okd62T5CERo7GLR","cls2":"Ts0QifrjKmhxcoNGL8lf MJkp9okd62T5CERo7GLR"};